/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEvent201Response
 */
export interface CreateEvent201Response {
    /**
     * 
     * @type {number}
     * @memberof CreateEvent201Response
     */
    id?: number;
}

/**
 * Check if a given object implements the CreateEvent201Response interface.
 */
export function instanceOfCreateEvent201Response(value: object): value is CreateEvent201Response {
    return true;
}

export function CreateEvent201ResponseFromJSON(json: any): CreateEvent201Response {
    return CreateEvent201ResponseFromJSONTyped(json, false);
}

export function CreateEvent201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEvent201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function CreateEvent201ResponseToJSON(json: any): CreateEvent201Response {
    return CreateEvent201ResponseToJSONTyped(json, false);
}

export function CreateEvent201ResponseToJSONTyped(value?: CreateEvent201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

